import { Injectable } from "@angular/core";
import { API_PATHS } from "@dentally/auth/auth-constants";
import { ConciergePatientLoginData } from "@dentally/auth/auth-types";
import { BaseAuthHttpService } from "@apps/patient-core/src/app/services/abstracts/auth-http.service";
import { catchError, Observable, of } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class ConciergeAuthHttpService extends BaseAuthHttpService {
  public handleDeviceLinked(jwt: string, nonce: string): Observable<any> {
    return this._post(
      API_PATHS.CONCIERGE_PAIRING,
      {
        nonce,
      },
      {
        headers: {
          Authorization: `Bearer ${jwt}`,
        },
      }
    );
  }

  public login(payload: ConciergePatientLoginData): Observable<{ accessToken: string } | { success: boolean; locked: boolean }> {
    return this._post<{ accessToken: string } | { success: boolean; locked: boolean }>(API_PATHS.CONCIERGE_LOGIN, payload).pipe(
      catchError((error) => {
        if (error.error && typeof error.error === "object" && ("locked" in error.error || "success" in error.error)) {
          return of(error.error);
        }

        throw error;
      })
    );
  }

  public getNewSession(): Observable<any> {
    return this._handlePublicAction(API_PATHS.CONCIERGE_NEW_SESSION);
  }

  public delete(): Observable<void> {
    return this._delete();
  }

  public logout(trigger: string): Observable<any> {
    return this._handlePublicAction(API_PATHS.CONCIERGE_LOGOUT, { trigger });
  }

  private _handlePublicAction(pathSuffix: string, params: Record<string, string> = {}): Observable<any> {
    return this._post<{ accessToken: string }>(pathSuffix, undefined, { params });
  }
}
